import React, {useEffect} from 'react'
import {useParams} from "react-router";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorList from "components/complex/papersGenerator/PapersGeneratorList";
import {makeStyles} from "@material-ui/styles";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    }
}))

function PurchasingGroupStage1PapersGenerator(
    {
        panelRef,
        validationSection
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const formId = params.section;
    const editable = validationSection.editable;

    useStepperStateCloseValidator(formId);

    useEffect(() => {
        PurchasingGroupSectionService.getSections(groupId, validationSection.section)
        PapersGeneratorService.getAvailablePapers(groupId);
        return () => {
            PapersGeneratorService.clearResources(PapersGeneratorService.PAPERS_GENERATOR_LIST_RESOURCE_ID);
        }
    }, [groupId, validationSection.section])

    return (<div className={classes.root}>
        <PapersGeneratorList editable={editable} id={groupId}/>
    </div>)
}

PurchasingGroupStage1PapersGenerator.propTypes = {}

export default PurchasingGroupStage1PapersGenerator;